<!--<progress [value]="value" max="100"></progress>-->
<div class="progress" [style.width.%]="value" [ngClass]="{'critical': value <= 20, 'warn': value <= 50}"></div>
